<template>
  <div id="app" :class="appClasses">
    <DesktopSidebar v-if="isDesktop" />
    <div class="app-main-wrap">
      <TopHeader v-if="showTopHeader" @wallet-authorized="handleWalletAuthorized" />
      <main class="main-content" :class="{ 'full-screen': $route.meta.hideHeader && !isDesktop }">
        <router-view />
      </main>
    </div>
    <BottomNavigation v-if="!$route.meta.hideBottomNav" />
  </div>
</template>

<script>
import TopHeader from './components/TopHeader.vue'
import BottomNavigation from './components/BottomNavigation.vue'
import DesktopSidebar from './components/DesktopSidebar.vue'
import domainService from './services/domainService.js'

export default {
  name: 'App',
  components: {
    TopHeader,
    BottomNavigation,
    DesktopSidebar
  },
  data() {
    return {
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0
    }
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= 769
    },
    isFlashOptions() {
      return this.$route.path === '/flash-options'
    },
    showTopHeader() {
      if (this.isDesktop) return true
      return !this.$route.meta.hideHeader
    },
    appClasses() {
      return {
        'desktop-layout': this.isDesktop,
        'fo-fullscreen': this.isDesktop && this.isFlashOptions
      }
    }
  },
  async mounted() {
    window.addEventListener('resize', this._onResize)
    try {
      await domainService.init()
    } catch (error) {
      console.error('域名服务初始化失败:', error)
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this._onResize)
  },
  methods: {
    _onResize() {
      this.windowWidth = window.innerWidth
    },
    handleWalletAuthorized() {
      this.refreshCustomerService()
    },
    async refreshCustomerService() {
      try {
        const userCustomerService = await domainService.getCurrentUserCustomerService()
        if (userCustomerService) {
          console.log('用户专属客服链接已更新:', userCustomerService)
        }
      } catch (error) {
        console.warn('刷新客服服务失败:', error)
      }
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  background: #f0f2f5;
  color: #1a2233;
  display: flex;
  flex-direction: column;
}

.app-main-wrap {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.main-content.full-screen { padding: 0; margin: 0; }

* { margin: 0; padding: 0; box-sizing: border-box; }

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  background: #f0f2f5;
  color: #1a2233;
}

/* ─── Desktop Layout ─── */
@media (min-width: 769px) {
  #app.desktop-layout {
    flex-direction: row;
  }

  #app.desktop-layout .app-main-wrap {
    margin-left: var(--po-sidebar-w, 64px);
    width: calc(100% - var(--po-sidebar-w, 64px));
    min-height: 100vh;
  }

  #app.desktop-layout .main-content {
    padding-bottom: 0 !important;
    padding-top: 0;
  }

  /* FlashOptions: hide sidebar, full screen */
  #app.fo-fullscreen .po-sidebar {
    display: none !important;
  }

  #app.fo-fullscreen .app-main-wrap {
    margin-left: 0;
    width: 100%;
  }
}
</style>
